<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <SharedCard :class="b()">
    <div :class="b('header')">
      <SharedBack @click="handleBack" />

      <h3 :class="b('header-title')">
        {{ $t("Крипто реквизиты") }}
      </h3>
    </div>

    <SharedInfoNotice :class="b('info')">
      <p>
        <strong>{{ $t("Это адрес для пополнения и вывода крипты.") }}</strong>
        {{
          $t(
            "Используйте только свой кошелёк и проверяйте сеть: перевод в другой сети восстановить нельзя."
          )
        }}
      </p>
      <p>
        {{
          $t(
            "Если поля нет — поставьте прочерк «—». Адрес проходит проверку перед первым выводом."
          )
        }}
      </p>
    </SharedInfoNotice>

    <div :class="b('form')">
      <SharedValidate
        field="name"
        :value="requisitesCryptoRequest.name"
        :is-validate="isValidate"
        :is-absolute="true"
        v-model:field-value="requisitesCryptoFields.name"
      >
        <div :class="b('form-group')">
          <h5 :class="b('form-title')">
            {{ $t("Название*") }}
          </h5>

          <UIInput view="light" v-model="requisitesCryptoRequest.name" />
        </div>
      </SharedValidate>

      <div :class="b('form-group')"></div>

      <div :class="b('form-group')"></div>

      <SharedValidate
        field="coin"
        :value="requisitesCryptoRequest.coin"
        :is-validate="isValidate"
        :is-absolute="true"
        v-model:field-value="requisitesCryptoFields.coin"
      >
        <div :class="b('form-group')">
          <h5 :class="b('form-title')">
            {{ $t("Монета*") }}
          </h5>

          <UIInput
            view="light"
            placeholder="—"
            placeholder-view="light"
            v-model="requisitesCryptoRequest.coin"
          />
        </div>
      </SharedValidate>

      <SharedValidate
        field="network"
        :value="requisitesCryptoRequest.network"
        :is-validate="isValidate"
        :is-absolute="true"
        v-model:field-value="requisitesCryptoFields.network"
      >
        <div :class="b('form-group')">
          <h5 :class="b('form-title')">
            {{ $t("Сеть*") }}
          </h5>

          <UIInput
            view="light"
            placeholder="—"
            placeholder-view="light"
            v-model="requisitesCryptoRequest.network"
          />
        </div>
      </SharedValidate>

      <SharedValidate
        field="address"
        :value="requisitesCryptoRequest.address"
        :is-validate="isValidate"
        :is-absolute="true"
        v-model:field-value="requisitesCryptoFields.address"
      >
        <div :class="b('form-group')">
          <h5 :class="b('form-title')">
            {{ $t("Адрес*") }}
          </h5>

          <UIInput view="light" v-model="requisitesCryptoRequest.address" />
        </div>
      </SharedValidate>
    </div>

    <div :class="b('note')">
      <h5 :class="b('note-title')">
        {{ $t("Комментарий") }}
      </h5>

      <UITextArea
        view="light"
        placeholder="Например: memo или название кошелька"
        placeholder-view="light"
        v-model="requisitesCryptoRequest.note"
      />
      <p :class="b('note-description')">
        {{ $t("Необязательно. Если memo не требуется — поставьте прочерк.") }}
      </p>
    </div>

    <UIButton
      :class="b('confirm')"
      label="Подтвердить"
      view="main"
      :disabled="isContinueDisabled"
      @click="handleContinue"
    />

    <transition name="opacity">
      <SettingsRequisitesVerification
        v-if="isVerification"
        :class="b('modal')"
        type="crypto-requisite"
        @close="handleVerificationClose"
      />
    </transition>
  </SharedCard>
</template>
